module.exports = __webpack_public_path__ + "img/boggshall-h-474x356.ca30ea19.jpg";